import { merge } from 'lodash';

export default {
  SET_LOADER_STATE(state, value) {
    state.ui.isLoaderActive = value;
  },
  SOCKET_CONNECTED(state) {
    state.socketConnected = true;
  },
  SOCKET_DISCONNECTED(state) {
    state.socketConnected = false;
  },
  SET_CMS_CONFIG(state, value) {
    state.cmsConfig = value;
  },
  SET_STAGE(state, value) {
    state.game.currentStage = value;
  },
  SET_RACE_ID(state, value) {
    state.game.raceId = value;
  },
  SET_EVENT_TIME(state, value) {
    state.game.eventTime[value.type] = value.time;
  },
  SET_COUNTDOWN_TIME(state, value) {
    state.game.countdownTime = value;
  },
  SET_GAME_ODDS(state, value) {
    state.game.offer = value;
  },
  SET_GAME_RESULTS(state, value) {
    state.game.results = value;
  },
  SET_WINNER_RESULTS(state, value) {
    state.game.results.winner = value;
  },
  SET_KNOCKOUT_RESULTS(state, value) {
    state.game.results.knockout = value;
  },
  SET_GAME_STATE_MODE(state, value) {
    state.game.stateMode = value;
  },
  SET_TOURNAMENT_ID(state, value) {
    state.game.tournamentId = value;
  },
  SET_VIDEO_ID(state, value) {
    state.game.videoId = value;
  },
  SET_RACE_START_TIME(state, value) {
    state.game.raceStartTime = value;
  },
  SET_INFO_MESSAGE(state, value) {
    state.ui.infoMessage = value;
  },
  UPDATE_TRANSLATIONS(state, value) {
    state.translations = merge({}, state.translations, value);
  },
};
